//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyBasePage from "../../components/MyBasePage";

export default {
  name: "Rules",
  components: {
    MyBasePage,
  },
  data() {
    return {
      hideTop: this.$route.query.hideTop,
    };
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Rules/index.vue